import {isNull, isObject, printObject} from 'src/utils/utils';

const readonlyMap = new WeakMap();
/**
 * 只读属性避免 循环调用
 * @param target
 */
export function readonly(target: any): any {
  if (isNull(target)) return null;
  if (!isObject(target)) return target;
  if (readonlyMap.has(target)) return readonlyMap.get(target);

  const proxy = new Proxy(target, {
    get(target, key: string, receiver) {
      const res = Reflect.get(target, key, receiver);
      //解决嵌套问题
      return isObject(res) ? readonly(res) : res;
    },

    set(target, key: string, value, receiver) {
      const oldValue = target[key];
      console.log(
        `readonly key = ${key} oldValue = ${oldValue} newValue = ${value}`,
      );
      return true;
    },
  });
  readonlyMap.set(target, proxy);
  return proxy;
}
